import { useState } from "react";
import { BottomNav } from "@jaiho/ui";
import { useAuth } from "../state/AuthContext";
import { ChatProvider } from "../state/ChatContext";
import { HomeScreen } from "../screens/HomeScreen";
import { GamesScreen } from "../screens/GamesScreen";
import { ChatScreen } from "../screens/ChatScreen";
import { RankingsScreen } from "../screens/RankingsScreen";
import { ProfileScreen } from "../screens/ProfileScreen";
import { BrandLogo } from "./BrandLogo";
import { ChatIcon, GamesIcon, HomeIcon, ProfileIcon, RankingsIcon } from "./icons";
import "./AppShell.css";

type Tab = "home" | "games" | "chat" | "rankings" | "profile";

const NAV_ITEMS: { key: Tab; label: string; icon: JSX.Element }[] = [
  { key: "home", label: "Home", icon: <HomeIcon /> },
  { key: "games", label: "Games", icon: <GamesIcon /> },
  { key: "chat", label: "Chat", icon: <ChatIcon /> },
  { key: "rankings", label: "Rankings", icon: <RankingsIcon /> },
  { key: "profile", label: "Profile", icon: <ProfileIcon /> },
];

export function AppShell() {
  const { status, error, me } = useAuth();
  const [tab, setTab] = useState<Tab>("home");

  if (status === "loading") {
    return (
      <div className="jaiho-boot">
        <BrandLogo size={64} className="jaiho-boot__mark" />
        <div className="jaiho-boot__status">Signing in…</div>
      </div>
    );
  }

  if (status === "error" || !me) {
    return (
      <div className="jaiho-boot">
        <BrandLogo size={64} className="jaiho-boot__mark" />
        <div className="jaiho-boot__status jaiho-boot__status--error">{error}</div>
      </div>
    );
  }

  return (
    <ChatProvider enabled={status === "ready"}>
      <div className="jaiho-shell">
        <div className="jaiho-shell__content">
          {tab === "home" && <HomeScreen />}
          {tab === "games" && <GamesScreen />}
          {tab === "chat" && <ChatScreen />}
          {tab === "rankings" && <RankingsScreen />}
          {tab === "profile" && <ProfileScreen />}
        </div>
        <BottomNav items={NAV_ITEMS} activeKey={tab} onSelect={(key) => setTab(key as Tab)} />
      </div>
    </ChatProvider>
  );
}
